// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"8640da58","508":"f9c2a5d5","886":"261c01de"}[chunkId] + ".js";
};